import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 匿名チャットのホーム`,
    languageButtonLabel: `言語`,
    languageModalTitle: `言語を選択`,
    languageModalCloseLabel: `言語メニューを閉じる`,
  },
  languageOptions: {
    'en-US': {
      label: `英語 (アメリカ合衆国)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英語 (ケニア)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英語 (ナイジェリア)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英語 (シンガポール)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `ポルトガル語 (ポルトガル)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `ポルトガル語 (ブラジル)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `ドイツ語 (ドイツ)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `ドイツ語 (オーストリア)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `ドイツ語 (スイス)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `スペイン語 (スペイン)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `フランス語 (フランス)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `イタリア語 (イタリア)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `オランダ語 (オランダ)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `ポーランド語 (ポーランド)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `スウェーデン語 (スウェーデン)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `デンマーク語 (デンマーク)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `フィンランド語 (フィンランド)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `ノルウェー語 (ノルウェー)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `アイスランド語 (アイスランド)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日本語 (日本)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韓国語 (韓国)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `中国語 (中国)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `広東語 (中華人民共和国香港特別行政区)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `ベトナム語 (ベトナム)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `タイ語 (タイ)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `インドネシア語 (インドネシア)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `スワヒリ語 (ケニア)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `ヒンディー語 (インド)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `ベンガル語 (バングラデシュ)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `マラーティー語 (インド)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `テルグ語 (インド)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `ペルシア語 (イラン)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `ウルドゥー語 (パキスタン)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `パンジャブ語 (パキスタン)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `ナイジェリア・ピジン語 (ナイジェリア)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `ロシア語 (ロシア)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `アラビア語 (サウジアラビア)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `アラビア語 (アラブ首長国連邦)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `アラビア語 (カタール)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `モロッコ・アラビア語 (モロッコ)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `トルコ語 (トルコ)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `言語を選択`,
    closeLabel: `言語メニューを閉じる`,
  },
  languageHint: (ctx) => `アカウントなしで ${ctx.localesCount}+ のロケールを行き来できます。`,
  readPagePrompt: ({languageLabel}) => `${languageLabel}でこのページを読む。`,
};
